<template>
	<div class="bettingRecord-user" :style="{ '--height': height, }">
		<div class="index-view-top">
			<van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
			<div class="title">{{ $t("user.bettingRecord") }}</div>
			<van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
		</div>
		<div class="data-time-picker">
			<div style="justify-content: unset;">
				<p style="margin-right:1rem">{{ $t("transactiondetails.type") }}：</p>
				<el-select v-model="value" :placeholder="tips" @change="valueChange">
					<el-option v-for="item in options" :key="item.value" :label="item.value" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div>
				<p>{{ $t("transactiondetails.date") }}：</p>
				<div class="dataPicker" @click="dataPickerShow = true">
					<p v-if="dataPickerRange">{{ dataPickerRange }}</p>
					<p v-else>{{ $t("transactiondetails.select_date") }}</p>
				</div>
				<van-calendar v-model:show="dataPickerShow" type="range" @confirm="onConfirm" :min-date="minDate"
					:max-date="maxDate" allow-same-day />
				<van-button color="#F8C007" @click="getWalletBidFlow" style="background: unset" plain>{{
						$t("transactiondetails.select")
				}}</van-button>
			</div>
		</div>
		<div class="money">
			<p @click="changeMoneyType('USDT')" :class="moneyType == 'USDT' ? 'active' : ''">
				USDT
			</p>
			<p @click="changeMoneyType('TRX')" :class="moneyType == 'TRX' ? 'active' : ''">
				TRX
			</p>
		</div>
		<div class="bettingmoney">
			<div>
				{{ $t("transactiondetails.bettingmoney") }}
			</div>
			<div>
				{{ $t("transactiondetails.winning_amount") }}
			</div>
			<div>
				{{ $t("transactiondetails.time") }}
			</div>
		</div>
		<ul class="infinite-list" v-infinite-scroll="load" style="overflow: auto">
			<div v-if="number.length < 1" style="padding:  3rem 0;color: #ffffff;text-align: center;">
				{{ $t("transactiondetails.not") }}
			</div>
			<div v-else class="details-lists" v-for="(item, index) in number" :key="index">
				<div>
					{{ item.flowPrice }}
				</div>
				<div>
					{{ item.bonus }}
				</div>
				<div>
					{{ item.createTime ? item.createTime.substring(0, 10) : '' }}
				</div>
			</div>
		</ul>
	</div>
</template>

<script>
import {
	walletBidFlow, dealFlow
} from "@/utils/request";
export default {
	data() {
		return {
			moneyType: "USDT",
			number: 10,
			monthValue: "",
			dataPickerShow: false,
			dataPickerRange: "",
			minDate: new Date(2010, 1, 1),
			maxDate: new Date(2050, 12, 31),
			height: '',//屏幕高度
			options: [],
			value: this.$t("transactiondetails.B1"),
			current: 1,
			tips: this.$t("transactiondetails.input_type"),//请选择类型
		};
	},
	//获取屏幕高度
	created() {
		let h = document.documentElement.clientHeight || document.body.clientHeight;
		if (h > 0) {
			this.height = h + 'px' //页面高度
		} else {
			this.height = "100vh"
		}
	},
	beforeMount(height) {
		if (this.$route.query.address) {
			this.options = [{
				value: this.$t("transactiondetails.B1"),
				label: "B1",
			},
			{
				value: this.$t("transactiondetails.B2"),
				label: "B2",
			},
			{
				value: this.$t("transactiondetails.B3"),
				label: "B3",
			},
			{
				value: this.$t("transactiondetails.B4"),
				label: "B4",
			},
			{
				value: this.$t("transactiondetails.B5"),
				label: "B5",
			},]
		} else {
			this.options = [{
				value: this.$t("transactiondetails.B1"),
				label: "B1",
			},
			{
				value: this.$t("transactiondetails.B2"),
				label: "B2",
			},
			{
				value: this.$t("transactiondetails.B3"),
				label: "B3",
			},
			{
				value: this.$t("transactiondetails.B4"),
				label: "B4",
			},
			{
				value: this.$t("transactiondetails.B5"),
				label: "B5",
			}, {
				value: this.$t("transactiondetails.A1"),
				label: "A1",
			},
			{
				value: this.$t("transactiondetails.A2"),
				label: "A2",
			},
			{
				value: this.$t("transactiondetails.A3"),
				label: "A3",
			},
			{
				value: this.$t("transactiondetails.A4"),
				label: "A4",
			},
			{
				value: this.$t("transactiondetails.A5"),
				label: "A5",
			}, {
				value: this.$t("transactiondetails.A6"),
				label: "A6",
			},
			{
				value: this.$t("transactiondetails.A7"),
				label: "A7",
			},
			{
				value: this.$t("transactiondetails.A8"),
				label: "A8",
			}]

		}
	},
	mounted() {
		this.getWalletBidFlow()
	},
	methods: {
		valueChange() {
		},
		//钱包下注记录
		getWalletBidFlow() {
			this.current = 1
			this.options.map((item) => {
				if (item.value == this.value) {
					if (this.$route.query.address) {
						walletBidFlow({
							coin: this.moneyType,
							type: item.label,
							address: this.$route.query.address,
							current: this.current,
							size: 20,
							time: this.dataPickerRange,
						}).then((res) => {
							if (res.code == "200") {
								this.number = res.data.records
							}
							if (res.code == '403') {
								localStorage.setItem('token', '')
								this.$router.push("/");
							}
						})
					} else {
						setTimeout(() => {
							dealFlow({
								coin: this.moneyType,
								type: item.label,
								current: this.current,
								size: 20,
								time: this.dataPickerRange,
							}).then((res) => {
								if (res.code == "200") {
									this.number = res.data.records
								}
								if (res.code == '403') {
									localStorage.setItem('token', '')
									this.$router.push("/");
								}
							})
						}, 100);
					}
				}
			})

		},
		onConfirm(value) {
			this.dataPickerRange =
				value[0].getFullYear() +
				"-" +
				(value[0].getMonth() + 1) +
				"-" +
				value[0].getDate() +
				" ~ " +
				value[1].getFullYear() +
				"-" +
				(value[1].getMonth() + 1) +
				"-" +
				value[1].getDate();
			this.dataPickerShow = false;
		},
		load() {
			this.options.map((item) => {
				if (item.value == this.value) {
					if (this.$route.query.address) {
						walletBidFlow({
							coin: this.moneyType,
							type: item.label,
							address: this.$route.query.address,
							current: this.current + 1,
							size: 20,
							time: this.dataPickerRange,
						}).then((res) => {
							if (res.code == "200") {
								if (res.data.records.length > 0) {
									this.current += 1
									this.number = [...this.number, ...res.data.records]
								}
							}
						})
					} else {
						dealFlow({
							coin: this.moneyType,
							current: this.current + 1,
							type: item.label,
							size: 20,
							time: this.dataPickerRange,
						}).then((res) => {
							if (res.code == "200") {
								if (res.data.records.length > 0) {
									this.current += 1
									this.number = [...this.number, ...res.data.records]
								}
							}
						})
					}
				}
			})

		},
		//选择币种类型
		changeMoneyType(item) {
			this.moneyType = item;
			this.getWalletBidFlow()
		},
		toBack() {
			this.$router.push("/user");
		},
	},
};
</script>
<style>
.el-select-dropdown {
	border: unset;
	background: unset;
	left: 0;
}

.el-select-dropdown__item.selected {
	background: #161414 !important;
}

.el-scrollbar {
	width: 18.75rem;
	background: #161414;
	border: unset;
}
</style>
<style lang="scss" scoped>
/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner {
	width: 12.5rem;
}

/deep/ .el-input__inner {
	background: #161414;
	border: unset !important;
	color: #FFFFFF;
}

/deep/ .van-button {
	height: unset;
	padding: 6px 15px;
}

.bettingRecord-user {
	width: 100vw;
	height: var(--height);
	background: #0c0b0b;

	.data-time-picker {
		padding: 0 0.9375rem;

		>div {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 3rem;

			.dataPicker {
				width: 62%;
				background: #161414;
				padding: 6px 0;

				>p {
					font-size: 0.8125rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
					padding-left: 1rem;
				}
			}

			>p {
				display: block;
				font-size: 0.8125rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
				height: 1rem;
			}
		}
	}

	.infinite-list {
		height: calc(var(--height) - 15.25rem);
	}

	.bettingmoney {
		display: flex;
		justify-content: space-between;
		padding: 0 0.9375rem;
		height: 2rem;

		div {
			font-size: 0.75rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #FFFFFF;
			width: 5.625rem;
		}

		div:nth-child(1) {
			text-align: left;
		}

		div:nth-child(2) {
			text-align: center;
		}

		div:nth-child(3) {
			text-align: right;
		}
	}

	.details-lists {
		padding: 0.9375rem 0.9375rem;
		border-bottom: 0.0625rem solid #272727;
		display: flex;
		justify-content: space-between;

		div {
			font-size: 0.75rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #999999;
			width: 5.625rem;
		}

		div:nth-child(1) {
			text-align: left;
		}

		div:nth-child(2) {
			text-align: center;
		}

		div:nth-child(3) {
			text-align: right;
		}

		// .item-top {
		// 	// display: flex;
		// 	// justify-content: space-between;
		// 	padding-bottom: 0.5rem;

		// 	>p {
		// 		font-size: 0.8125rem;
		// 		font-family: PingFang SC-Medium, PingFang SC;
		// 		font-weight: 500;
		// 		color: #ffffff;
		// 	}
		// }

		// .item-bottom {
		// 	// display: flex;
		// 	// justify-content: space-between;

		// 	>p {
		// 		font-size: 0.8125rem;
		// 		font-family: PingFang SC-Medium, PingFang SC;
		// 		font-weight: 500;
		// 		color: #999999;
		// 	}
		// }
	}

	.money {
		display: flex;
		justify-content: space-around;
		padding: 1rem 0;

		.active {
			color: #ffc400 !important;
			border-bottom: 0.0625rem solid #ffc400;
		}

		>p {
			font-size: 0.875rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #999999;
			padding-bottom: 0.25rem;
		}
	}

	.index-view-top {
		height: 3.625rem;
		padding: 0 0.9375rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.title {
			font-size: 1.125rem;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #ffffff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/user/bettingRecord.vue